import { motion } from 'framer-motion';
import PremiumCasinoChip from 'components/PremiumCasinoChip';

interface ChipStackProps {
  count?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  animated?: boolean;
  className?: string;
  multicolor?: boolean;
  /** stack = vertical pile; cluster = tight horizontal pile for pot center */
  layout?: 'stack' | 'cluster';
}

const SIZE = {
  xs: { chip: 18, stack: 1, gap: 2 },
  sm: { chip: 32, stack: 2, gap: 5 },
  md: { chip: 40, stack: 4, gap: 6 },
  lg: { chip: 48, stack: 5, gap: 7 },
};

export default function ChipStack({
  count,
  size = 'md',
  animated,
  className = '',
  multicolor = true,
  layout = 'stack',
}: ChipStackProps) {
  const s = SIZE[size];
  const chips = count != null ? Math.min(count, s.stack) : s.stack;
  const isCluster = layout === 'cluster';

  return (
    <div
      className={`relative inline-flex items-center ${isCluster ? 'flex-row' : 'flex-col'} ${className}`}
      aria-hidden
    >
      {Array.from({ length: chips }).map((_, i) => {
        const isTop = i === chips - 1;
        return (
          <motion.div
            key={i}
            style={{
              marginTop: !isCluster && i > 0 ? -s.gap : 0,
              marginLeft: isCluster && i > 0 ? -s.gap * 1.6 : 0,
            }}
            animate={animated && isTop ? { y: [0, -2, 0] } : undefined}
            transition={animated ? { duration: 2.4, repeat: Infinity, delay: i * 0.1, ease: 'easeInOut' } : undefined}
          >
            <PremiumCasinoChip
              size={s.chip}
              variant={multicolor ? i : 0}
            />
          </motion.div>
        );
      })}
    </div>
  );
}

export function PokerChip({ color = 0, className = '' }: { color?: number; className?: string }) {
  return (
    <div className={className}>
      <PremiumCasinoChip size={36} variant={color} />
    </div>
  );
}
